import { Component, OnInit, TemplateRef, ViewChild, Input } from "@angular/core";
import { PortalService } from "../../services/portal-service.service";
import { UntypedFormGroup } from "@angular/forms";
import { Contracts } from "../../models/contracts";
import { Activations } from "../../models/activations";
import { ActivationDetailsComponent } from "../activation-details/activation-details.component";
import { SurrenderItem, SurrenderLicense } from "../../models/tokens";
import { LogService } from "../../services/log.service";
import { MatDialog } from "@angular/material/dialog";
import { firstValueFrom } from "rxjs";
import { CristieUtils } from "../../core/utils.service";

@Component({
  standalone: false,
  selector: "app-license-surrender",
  templateUrl: "./license-surrender.component.html",
  styleUrls: ["./license-surrender.component.scss"],
})
export class LicenseSurrenderComponent implements OnInit {
  @ViewChild("confirmSurrenderModal")
  confirmSurrenderModalRef: TemplateRef<any>;
  @ViewChild("surrenderModal") surrenderModalRef: TemplateRef<any>;
  @ViewChild(ActivationDetailsComponent)
  ActivationDetailsComponent: ActivationDetailsComponent;
  @Input() contract: Contracts;
  @Input() showComments = false;
  SurrenderLicenseForm: UntypedFormGroup;
  contracts = new Array<Contracts>();
  activations = new Array<Activations>();
  showTokens = false;

  error: any = null;
  success = false;
  failed = false;
  closeResult: string;
  removed: any = [];
  removeFailed: any = [];
  selections = false;
  loading = true;
  processing = false;

  constructor(
    private portalService: PortalService,
    private dialog: MatDialog,
    private logService: LogService,
  ) {}

  ngOnInit() {
    this.getActivations(this.contract.id);
    this.showTokens = this.portalService.showTokens(this.contract);
  }

  get f() {
    return this.SurrenderLicenseForm.controls;
  }

  get mailtoLinkSurrender(): string {
    const subject = encodeURIComponent("Surrender Increase Request");
    const body = encodeURIComponent(`Hello Support,
  
  I require a surrender increase on contract ${this.contract.id}.`);
    return `mailto:support@example.com?subject=${subject}&body=${body}`;
  }

  getActivations(contractId: number) {
    this.loading = true;
    return this.portalService.GetActivations(contractId).subscribe(
      (data: Activations[]) => {
        this.activations = data.filter((a) => a.dateSurrendered == null);
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }

  get c() {
    return this.ActivationDetailsComponent.ActivationsForm.controls.returns;
  }

  surrenderLicenses() {
    if (this.selectedActivations.length > 0) {
      this.dialog.open(this.confirmSurrenderModalRef, { width: "640px" });
    }
  }

  async confirmSurrender(): Promise<void> {
    if (this.processing) return;
    this.closeDialog();
    this.resetMessage();
    this.processing = true;
    this.openResultModal(this.surrenderModalRef);

    for (const activation of this.selectedActivations) {
      await this.surrenderLicense(activation);
    }

    this.processing = false;
    this.success = this.removed.length > 0;
    this.failed = this.removeFailed.length > 0;
  }

  get selectedActivations(): Activations[] {
    return this.activations.filter((activation) => activation.selected);
  }

  async surrenderLicense(a: Activations): Promise<void> {
    const today = new Date().toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const license = new SurrenderLicense();
    const item = new SurrenderItem();
    // data item sent to API
    license.product = a.product.toUpperCase();
    license.code = a.code;
    license.comment = `Returned on ${today} by ${CristieUtils.decodeBase64(localStorage.getItem("name"))}`;

    // Front end model so we can tell what has succeded and failed
    item.code = a.code;
    item.hostname = a.hostname;
    try {
      const response = await firstValueFrom(this.portalService.SurrenderLicense(this.contract.id, Array(license)));
      if (response == null) {
        this.removed.push(item);
      } else {
        this.removeFailed.push(item);
      }
    } catch (error) {
      this.logService.log("Surrender License failed with: ", error);
      this.logService.log("faileditem", item);
      this.removeFailed.push(item);
      this.error = error;
    }
  }

  resetMessage() {
    this.failed = false;
    this.error = null;
    this.success = false;
  }

  openResultModal(content) {
    this.dialog
      .open(content, { width: "960px", disableClose: true })
      .afterClosed()
      .subscribe(async () => {
        this.reset();
        this.contract = await this.portalService.queryContract(this.contract.id);
        this.getActivations(this.contract.id);
      });
  }

  closeDialog(): void {
    if (this.processing) return;
    this.dialog.closeAll();
  }

  reset() {
    this.removed = [];
    this.removeFailed = [];
    this.failed = false;
    this.error = null;
    this.success = false;
    this.processing = false;
  }
} // end
